import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { BaseCaptureQueueSettingsComponent } from '../capture-queue/base-capture-queue-settings';
import { FormsModule } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { ExcludeInputPatternDirective } from '../../../shared/directives/exclude-input-pattern.directive';
import { DecimalPipe } from '@angular/common';
import { ClientSelectComponent } from '../../../shared/components/client-select/client-select.component';

@Component({
    selector: 'app-capture-queue-settings',
    templateUrl: './capture-queue-settings.component.html',
    styleUrls: ['./capture-queue-settings.component.scss'],
    imports: [FormsModule, ClientSelectComponent, NgSelectComponent,
      MatSlideToggle, ExcludeInputPatternDirective, DecimalPipe]
})
export class CaptureQueueSettingsComponent extends BaseCaptureQueueSettingsComponent {
  @Input() disableSearch = false;
  @Output() performSearch = new EventEmitter();
  @Output() performReset = new EventEmitter();

  refreshCaptureCount$: Subject<void> = new Subject();
  captureCountLoaded = false;
  captureCount = 0;

  protected initialize() {
    super.initialize();
    this.configureRefreshCaptureCount();
  }

  onSearchClick() {
    this.performSearch.emit();
    this.refreshCaptureCount$.next();
  }

  handleResetClick($event) {
    super.handleResetClick($event);
    this.performReset.emit();
  }

  private configureRefreshCaptureCount() {
    this.refreshCaptureCount$
      .pipe(
        tap(() => {
          this.captureCountLoaded = false;
        }),
        switchMap(() => this.captureQueueService.getCount())
      )
      .subscribe((result) => {
        this.captureCountLoaded = true;
        this.captureCount = result.count;
      });
  }
}
